export default {
  optionsForSelect: state => {
    return state.groups.map(e => ({label: e.name, value: e.id}))
  }
}
